import TextInput from "../../components/TextInput";
import ComponentThemeType from "../../models/ComponentTheme";
import { useState } from "react";
import { View } from "react-native";
import { white_smoke } from "../../StyleHelpers";
import { globalAny, hasValue, isInCarScreen } from "../../utils/Utils";
import { StyledCardContainer, StyledNameContainer, StyleHalfInput } from "./styled";

const CardDetails = (props: any) => {
	const [cardExpiry, setCardExpiry] = useState(props.cardExpiry);
	const [firstName, setFirstName] = useState(props.firstName);
	const [lastName, setLastName] = useState(props.lastName);

	const stylesInput = {
		height: props.isNarrow ? 55 : 80,
		borderRadius: 16,
		borderWidth: 2,
		borderStyle: "solid",
		borderColor: "rgb(147,143,153)",
		paddingLeft: 20,
		backgroundColor: "transparent",
	};

	const stylesLabel = {
		top: props.isNarrow ? 17.5 : 27,
		backgroundColor: "#141414",
		fontSize: props.isNarrow ? 21 : 25,
		paddingLeft: 8,
		paddingRight: 8,
		color: white_smoke,
	};

	const stylesCardLabel = {
		top: props.isNarrow ? 17.5 : 25,
		backgroundColor: "#141414",
		fontSize: props.isNarrow ? 21 : 27,
		opacity: 1,
		paddingLeft: 8,
		paddingRight: 100,
		color: white_smoke,
	};

	const formatExpiry = (text: any) => {
		const formattedText = text.replace(/[^0-9, /]/g, "");
		if (text.length > 2 && text.length < 5 && text.indexOf("/") === -1) {
			props?.setCardExpiry(`${formattedText.slice(0, 2)}/${formattedText.slice(2, formattedText.length)}`);
			setCardExpiry(`${formattedText.slice(0, 2)}/${formattedText.slice(2, formattedText.length)}`);
		} else {
			if (text.length > 5) return;
			props?.setCardExpiry(formattedText);
			setCardExpiry(formattedText);
		}
	};

	return (
		<>
			{/**@ts-ignore */}
			<StyledCardContainer isShow={props.show}>
				{/**@ts-ignore */}
				<StyledNameContainer isNarrow={props.isNarrow}>
					{/**@ts-ignore */}
					<StyleHalfInput isBottom>
						<TextInput
							nativeID={"cardholderFirstName"}
							componentTheme={ComponentThemeType.VinFast}
							label={globalAny.language.first_name}
							placeholder={globalAny.language.first_name}
							autoFocus={true}
							onChangeText={(text) => {
								if (isInCarScreen()) return;
								props?.setFirstName(text);
								setFirstName(text);
								props.debouncedOnChange(text);
							}}
							onChange={(e) => {
								if (!isInCarScreen()) return;
								props?.setFirstName(e.nativeEvent.text);
								setFirstName(e.nativeEvent.text);
								props.debouncedOnChange(e.nativeEvent.text);
							}}
							onEndEditing={(e) => {
								if (!isInCarScreen()) return;
								props?.setFirstName(e.nativeEvent.text);
								setFirstName(e.nativeEvent.text);
							}}
							onSubmitEditing={(e) => {
								if (!isInCarScreen()) return;
								props?.setFirstName(e.nativeEvent.text);
								setFirstName(e.nativeEvent.text);
							}}
							onBlur={() => {
								if (!isInCarScreen()) return;
								props?.setFirstName(firstName);
								setFirstName(firstName);
							}}
							value={firstName}
							capitalizeFirstCharacter={true}
							hasValue={hasValue(firstName)}
							isHideError={true}
						/>
						<TextInput
							nativeID={"cardholderLastName"}
							componentTheme={ComponentThemeType.VinFast}
							label={globalAny.language.last_name}
							placeholder={globalAny.language.last_name}
							onChangeText={(text) => {
								if (isInCarScreen()) return;
								setLastName(text);
								props?.setLastName(text);
								props.debouncedOnChange(text);
							}}
							onChange={(e) => {
								if (!isInCarScreen()) return;
								setLastName(e.nativeEvent.text);
								props?.setLastName(e.nativeEvent.text);
								props.debouncedOnChange(e.nativeEvent.text);
							}}
							onEndEditing={(e) => {
								if (!isInCarScreen()) return;
								props?.setLastName(e.nativeEvent.text);
								setLastName(e.nativeEvent.text);
							}}
							onSubmitEditing={(e) => {
								if (!isInCarScreen()) return;
								props?.setLastName(e.nativeEvent.text);
								setLastName(e.nativeEvent.text);
							}}
							onBlur={() => {
								if (!isInCarScreen()) return;
								props?.setLastName(lastName);
								setLastName(lastName);
							}}
							value={lastName}
							capitalizeFirstCharacter={true}
							hasValue={hasValue(lastName)}
							isHideError={true}
						/>
					</StyleHalfInput>
					<View>
						<div className="floating-label-content">
							<div id="number-container" className="floating-input" style={stylesInput} />
							<label className="floating-label" id="floating-label" style={stylesCardLabel}>
								<span id="cardNumberPadding" style={{ paddingLeft: 10 }}>
									{globalAny.language.card_number}
								</span>
							</label>
						</div>
					</View>
					{/**@ts-ignore */}
					<StyleHalfInput>
						<TextInput
							value={cardExpiry}
							keyboardType={"numeric"}
							nativeID={"expiryDate"}
							componentTheme={ComponentThemeType.VinFast}
							label={globalAny.language.expiry_date}
							placeholder={"MM/YY"}
							error={props.isExpiryError}
							isHideError={true}
							onChangeText={(text) => {
								if (text.length > 5 || isInCarScreen()) return;
								props?.setCardExpiry(text);
								setCardExpiry(text);
								formatExpiry(text);
								props.setExpiryError(false);
								props.debouncedOnChange();
							}}
							onChange={(e) => {
								const date = e.nativeEvent.text;
								if (date.length > 5 || !isInCarScreen()) return;
								props?.setCardExpiry(date);
								setCardExpiry(date);
								props.setExpiryError(false);
								props.debouncedOnChange();
							}}
							onSubmitEditing={(e) => {
								if (!isInCarScreen()) return;
								const date = e.nativeEvent.text;
								formatExpiry(date);
							}}
							onEndEditing={(e) => {
								if (!isInCarScreen()) return;
								const date = e.nativeEvent.text;
								formatExpiry(date);
							}}
							onBlur={() => {
								if (!isInCarScreen()) return;
								formatExpiry(cardExpiry);
							}}
							maxLength={7}
							hasValue={hasValue(cardExpiry)}
						/>
						<View style={{ width: "49%", marginTop: 5 }}>
							<div className="floating-label-content">
								<div id="securityCode-container" className="floating-input" style={stylesInput} />
								<label className="floating-label" id="floating-label-securityCode" style={stylesLabel}>
									<span id="securityCodePadding">CCV/CVC</span>
								</label>
							</div>
						</View>
					</StyleHalfInput>
				</StyledNameContainer>
			</StyledCardContainer>
		</>
	);
};

export default CardDetails;
